module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"error-msg":"Der Server ist momentan nicht erreichbar","btn-go-home":"Home"},"fr":{"error-msg":"Le serveur est actuellement injoignable","btn-go-home":"Accueil"},"it":{"error-msg":"Il server non è attualmente disponibile","btn-go-home":"Home"}}')
  delete Component.options._Ctor
}
